import { render } from "./manufacture.vue?vue&type=template&id=899f0ae8&scoped=true"
import script from "./manufacture.vue?vue&type=script&lang=js"
export * from "./manufacture.vue?vue&type=script&lang=js"

import "./manufacture.vue?vue&type=style&index=0&id=899f0ae8&scoped=true&lang=less"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-899f0ae8"]])

export default __exports__